import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import I18n from '../../localization';
import Icon from '../../utils/icons';

import PubSub from 'pubsub-js'
import { EVSE_NATIVE_METHODS } from '../../utils/constant';
import { fontClasses } from '../../fontStyles';
import { isiOS } from '../../utils/utility';
import CustomPopup from '../CustomPopup';
import PopUp from '../PopUp';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    width: '100% !important',
    height: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
    zIndex: 100,
    background: `${theme.palette.primary.header} !important`,
    display: 'flex',
    top: 0,
    left: 0,
    rigth: 0,
    overflow: 'hidden',
  },
  innerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100% !important',
    flex: 1,
    minWidth: 0,
    margin: (props) => props.label
      ? isiOS()
        ? 'calc(14px + env(safe-area-inset-top)) 20px 14px 20px'
        : '14px 20px'
      : isiOS()
        ? 'calc(19.5px + env(safe-area-inset-top)) 20px 19.5px 20px'
        : '19.5px 20px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto !important',
    width: 'auto !important',
    paddingTop: '10px',
    paddingBottom: '10px',
    flex: 1,
    minWidth: 0,
    '& svg': {
      fill: `${theme.palette.primary.headerTitle} !important`,
    }
  },
  prevIcon: {
    marginRight: '10px',
    verticalAlign: 'middle' // Add this style
  },
  iconConatiner: {
    opacity: 1,
    marginTop: '-3px',
    marginRight: '8px',
    cursor: 'pointer',
    display: 'flex',
    textAlign: 'center',
    alignSelf: 'center',
  },
  title: {
    fontSize: '20px',
    marginBottom: '1px',
    color: `${theme.palette.primary.headerTitle} !important`,
    backgroundColor: 'inherit !important',
    ...fontClasses.title2,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  customLabel: {
    fontSize: '12px !important',
    marginTop: '-2px !important',
    color: `${theme.palette.primary.headerTitle} !important`,
    backgroundColor: 'inherit !important',
    wordBreak: 'break-word'
  },
  restarBtn: {
    ...fontClasses.title2,
    color: `${theme.palette.tertiary.provisionRestartBtn} !important`,
  },
  headerContent: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  threeDots: {
    padding: '5px'
  },
  threeDotsPopupItem: {
    position: "fixed",
    zIndex: 1000,
    top: "44px",
    right: "20px",
    background: "#fff",
    color: "#545456",
    borderRadius: '6px',
    boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
    display: "inline-flex",
    padding: '12px 12px 12px 12px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px'
  },
  threeDotsPopupItemContent: {
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    alignSelf: 'stretch',
    textAlign: 'right'
  },
  btnHeader: {
    marginBottom: "10px",
    marginRight: "12px",
    ...fontClasses.title2,
    color: '#fff !important'
  }
}));

export const Header = props => {
  const classes = useStyles(props);
  const [isOpenReset, OpenReset] = useState(false);
  const [onBackbtnConfirmation, setBackbtnConfirmation] = useState(false);

  const handleDeviceBackButton = () => {
    const getDidPressBackButton = function (event, data) {
      console.log("Device Back button detected on React!");
      if (props.mainScreen === "provision" && !props.deviceCreated) {
        setBackbtnConfirmation(true);
      } else {
        props.onClick();
      }
    }
    PubSub.unsubscribe(EVSE_NATIVE_METHODS.DID_PRESS_BACK_BUTTON);
    PubSub.subscribe(EVSE_NATIVE_METHODS.DID_PRESS_BACK_BUTTON, getDidPressBackButton);
  }


  useEffect(() => {
    handleDeviceBackButton();
    return () => {
      // Anything in here is fired on component unmount.
      PubSub.unsubscribe(EVSE_NATIVE_METHODS.DID_PRESS_BACK_BUTTON);
    }
  }, [])


  return (
    <>
      {!props.showNewItkUi &&
        <Box className={classes.wrapper}>
          <Box className={classes.innerWrapper}>
            <Box className={classes.header} onClick={() => props.mainScreen === "provision" && !props.deviceCreated ? setBackbtnConfirmation(true) : props.onClick()}>
              <span className={classes.iconConatiner}>
                <Icon src="prev" width={11} height={20} className={classes.prevIcon} />
              </span>
              <Box className={classes.headerContent}>
                <Typography className={classes.title}>
                  {props.title}
                </Typography>
                {props.label && <Typography className={classes.customLabel}>{props.label}</Typography>}
              </Box>
            </Box>
            {props.step > 0 && props.step < 4 && props.animationStatus === false ?
              <Box className={classes.restarBtn} onClick={() => OpenReset(true)}>
                {I18n.t('mobile.component.restart')}
              </Box>
              : null
            }
          </Box>
        </Box>
      }

      <PopUp
        open={isOpenReset}
        handleClose={() => OpenReset(false)}
        content={<CustomPopup title={I18n.t('mobile.component.restart')}
          leftAction={() => { OpenReset(false) }}
          rightAction={() => { props.handleReset(); OpenReset(false) }}
          newUI={true}
          isDarkMode={props.isDarkMode}
          message={I18n.t('mobile.component.endTheProcessAndRestart')} leftButtonText={I18n.t('mobile.common.dismiss')} rightButtonText={I18n.t('mobile.component.restart')}/>}
        disableBackdropClick
        isDarkMode={props.isDarkMode}
      />

      <PopUp
        open={onBackbtnConfirmation}
        handleClose={() => OpenReset(false)}
        content={<CustomPopup title={I18n.t('mobile.EvProvision.confirmation')}
          leftAction={() => { setBackbtnConfirmation(false) }}
          rightAction={() => { props.onClick(); setBackbtnConfirmation(false) }}
          newUI={true}
          isDarkMode={props.isDarkMode}
          message={I18n.t('mobile.component.changesNotSavedSureCancelProcess')} leftButtonText={I18n.t('mobile.common.dismiss')} rightButtonText={I18n.t('mobile.EvProvision.confirm')} />
        }
        isDarkMode={props.isDarkMode}
        disableBackdropClick

      />

    </>

  );
};
